import { useContext } from 'react'
import { replace } from 'ramda'
import BootstrapDataContext from '../../context/BootstrapDataContext'

export default function useFirstNameInAceContentForVIP(
  firstName: string,
  aceKey: string
) {
  const { aceContent = {} } = useContext(BootstrapDataContext)
  if (firstName && aceContent?.contentValues?.VIPHOMEPAGE?.[aceKey]?.value) {
    aceContent.contentValues.VIPHOMEPAGE[aceKey].value = replace(
      '{firstName}',
      firstName,
      aceContent.contentValues.VIPHOMEPAGE[aceKey].value
    )
  }
}
